import KeyValueListDisplay from '@/components/KeyValueDisplay';
import { convertISODateToMMDDYYYY, formatPhoneNumber } from '@/lib/utils';
import type { CaseResponse } from '@/types/case.types';
import { JURISDICTION_OPTIONS, PROPERTY_ADDRESS_CASE_TYPE, RUSH_TYPE_OPTIONS } from '@/utils/constant';

export const CaseDetailsPeContent = ({ data }: { data: CaseResponse | undefined }) => {
  const caseDetails = [
    {
      label: 'Jurisdiction',
      value: JURISDICTION_OPTIONS.find((jurisdiction) => jurisdiction.value === data?.jurisdiction)?.label ?? '-',
    },
    { label: 'Case Type', value: data?.type.name ?? '-' },
    { label: 'Court Name', value: data?.court.name ?? '-' },
    { label: 'Case #', value: data?.number ?? '-' },
    { label: 'Case Name', value: data?.name ?? '-' },
    { label: 'File #', value: data?.fileNo ?? '-' },
    { label: 'Plaintiff', value: data?.plaintiff ?? '-' },
    { label: 'Defendant', value: data?.defendant ?? '-' },
    ...(data?.typeId && PROPERTY_ADDRESS_CASE_TYPE.includes(data?.typeId)
      ? [
          {
            label: 'Address',
            value: [data?.address1, data?.address2, data?.city, data?.state + ' ' + data?.zipCode]
              .filter(Boolean)
              .join(', '),
          },
        ]
      : []),
  ];
  const dateDetails = [
    {
      label: 'Serve By',
      value: data?.serveBy ? convertISODateToMMDDYYYY(data?.serveBy) : '-',
    },
    {
      label: 'Hearing',
      value: data?.hearingOn ? convertISODateToMMDDYYYY(data?.hearingOn) : '-',
    },
    {
      label: 'Rush',
      value: RUSH_TYPE_OPTIONS.find((rush) => rush.value === data?.rush)?.label ?? 'No',
    },
  ];
  const insuranceData = [
    { label: 'Adjuster', value: data?.insurance?.adjuster ?? '-' },
    { label: "Adjuster's Name", value: data?.insurance?.adjusterName ?? '-' },
    { label: 'Insured Name', value: data?.insurance?.insuredName ?? '-' },
    { label: 'Phone Number', value: data?.insurance?.phone ? formatPhoneNumber(data?.insurance?.phone) : '-' },
    { label: 'Fax', value: data?.insurance?.fax ?? '-' },
    {
      label: 'Date of Loss',
      value: data?.insurance?.dateOfLoss ? convertISODateToMMDDYYYY(data?.insurance?.dateOfLoss) : '-',
    },
    { label: 'Bill To #', value: data?.insurance?.billTo ?? '-' },
    { label: 'Policy #', value: data?.insurance?.policy ?? '-' },
    { label: 'Claim #', value: data?.insurance?.claim ?? '-' },
  ];
  return (
    <div className="flex flex-col gap-6 w-full px-6 py-6 text-sm">
      <div className="flex flex-col gap-2">
        <KeyValueListDisplay data={caseDetails} />
      </div>
      <hr />
      <div className="flex flex-col gap-4">
        <span className="font-semibold text-sm">Dates</span>
        <div className="flex flex-col gap-2 text-sm">
          <KeyValueListDisplay data={dateDetails} />
        </div>
      </div>
      <hr />
      <div className="flex flex-col gap-4 text-sm">
        <div className="flex flex-row justify-between items-center">
          <span className="font-semibold text-sm">Insurance Data</span>
          {!data?.insurance && <span className="text-sm">No</span>}
        </div>
        {data?.insurance && (
          <div className="flex flex-col gap-2">
            <KeyValueListDisplay data={insuranceData} />
          </div>
        )}
      </div>
    </div>
  );
};
export default CaseDetailsPeContent;
